"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupPlayersSyncListeners = void 0;
const models_1 = require("@creature-chess/models");
const state_1 = require("./state");
/**
 * Listener-middleware adapter routing playerInfo/* wire updates into the
 * `players` slice. The wire shape carries no player id (these actions only
 * concern the local Player); we read it from `extra.accountIdHolder` and tag
 * the dispatch.
 */
const setupPlayersSyncListeners = (startListening) => {
    startListening({
        actionCreator: models_1.PlayerCommands.playerInfoCommands.updateHealthCommand,
        effect: ({ payload }, api) => {
            const id = api.extra.accountIdHolder.peek();
            if (!id) {
                return;
            }
            api.dispatch(state_1.playersActions.setLocalHealth({ id, health: payload }));
        },
    });
    startListening({
        actionCreator: models_1.PlayerCommands.playerInfoCommands.updateMoneyCommand,
        effect: ({ payload }, api) => {
            const id = api.extra.accountIdHolder.peek();
            if (!id) {
                return;
            }
            api.dispatch(state_1.playersActions.setLocalMoney({ id, money: payload }));
        },
    });
    startListening({
        actionCreator: models_1.PlayerCommands.playerInfoCommands.updateLevelCommand,
        effect: ({ payload }, api) => {
            const id = api.extra.accountIdHolder.peek();
            if (!id) {
                return;
            }
            api.dispatch(state_1.playersActions.setLocalLevel({ id, level: payload.level }));
        },
    });
    startListening({
        actionCreator: models_1.PlayerCommands.playerInfoCommands.updateReadyCommand,
        effect: ({ payload }, api) => {
            const id = api.extra.accountIdHolder.peek();
            if (!id) {
                return;
            }
            api.dispatch(state_1.playersActions.setLocalReady({ id, ready: payload }));
        },
    });
    startListening({
        actionCreator: models_1.PlayerCommands.playerInfoCommands.updateStreakCommand,
        effect: ({ payload }, api) => {
            const id = api.extra.accountIdHolder.peek();
            if (!id) {
                return;
            }
            api.dispatch(state_1.playersActions.setLocalStreak({
                id,
                streakType: payload.type,
                streakAmount: payload.amount,
            }));
        },
    });
    startListening({
        actionCreator: models_1.PlayerCommands.playerInfoCommands.updateBattleCommand,
        effect: ({ payload }, api) => {
            const id = api.extra.accountIdHolder.peek();
            if (!id) {
                return;
            }
            api.dispatch(state_1.playersActions.setLocalBattle({ id, battle: payload }));
        },
    });
    startListening({
        actionCreator: models_1.PlayerCommands.playerInfoCommands.updateStatusCommand,
        effect: ({ payload }, api) => {
            const id = api.extra.accountIdHolder.peek();
            if (!id) {
                return;
            }
            api.dispatch(state_1.playersActions.setLocalStatus({ id, status: payload }));
        },
    });
};
exports.setupPlayersSyncListeners = setupPlayersSyncListeners;
